/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API,
};
export default {
  //消息推送配置
  pushMsgConfig: {
    query:`${base.url}/crs36/pushmsgconfig/list`,
    save: `${base.url}/crs36/pushmsgconfig/save`,
    edit: `${base.url}/crs36/pushmsgconfig/edit`,
    del: `${base.url}/crs36/pushmsgconfig/del`,
  },
  pushMsgLog: {
    uploadTemplate:`${base.url}/crs36/msgpushlog/uploadTemplate`,
    save:`${base.url}/crs36/msgpushlog/save`,
    query:`${base.url}/crs36/msgpushlog/list`,
    getEnv:`${base.url}/crs36/msgpushlog/getEnv`,
    setEnv:`${base.url}/crs36/msgpushlog/setEnv`,
    upload:`${base.url}/cloud/file/uploadImage`,
  },
  pushMsg: {
    uploadTemplate:`${base.url}/crs36/pushMsg/uploadTemplate`,
    query:`${base.url}/crs36/pushMsg/list`,
    save: `${base.url}/crs36/pushMsg/save`,
    edit: `${base.url}/crs36/pushMsg/edit`,
    del: `${base.url}/crs36/pushMsg/del`,
    status: `${base.url}/crs36/pushMsg/status`,
    getData: `${base.url}/crs36/pushMsg/getData`,
    push: `${base.url}/crs36/pushMsg/push`,
    startOrStop: `${base.url}/crs36/pushMsg/startOrStop`,
    editMongoMsg: `${base.url}/crs36/pushMsg/editMongoMsg`,
    deletMongoMsg: `${base.url}/crs36/pushMsg/deletMongoMsg`,
  },
  ceGroup: {
    list:`${base.url}/crs36/ceGroup/list`,
    save:`${base.url}/crs36/ceGroup/save`,
    validationData: `${base.url}/crs36/ceGroup/validationData`,
    get: `${base.url}/crs36/ceGroup/get`,
    open: `${base.url}/crs36/ceGroup/open`,
    synGroupUserList: `${base.url}/crs36/ceGroup/synGroupUserList`,
    userList: `${base.url}/crs36/ceUser/list`,
    userSave: `${base.url}/crs36/ceUser/save`,
    userDel: `${base.url}/crs36/ceUser/del`,
    userExport: `${base.url}/crs36/ceUser/export`,
  },
  templateMsg: {
    query:`${base.url}/crs36/templateMsg/list`,
    save: `${base.url}/crs36/templateMsg/save`,
    edit: `${base.url}/crs36/templateMsg/edit`,
    del: `${base.url}/crs36/templateMsg/del`,
    status: `${base.url}/crs36/templateMsg/status`,
    getData: `${base.url}/crs36/templateMsg/getData`,
  },
  templateRecord: {
    query:`${base.url}/crs36/templateMsgRecord/list`,
  },
  active:{
      channel:{
        query:`${base.url}/crs36/activechannel/list`,
        queryAll:`${base.url}/crs36/activechannel/listAll`,
        save:`${base.url}/crs36/activechannel/save`,
        edit:`${base.url}/crs36/activechannel/edit`,
        del:`${base.url}/crs36/activechannel/del`,
      },
      active:{
        query:`${base.url}/crs36/active/list`,
        save:`${base.url}/crs36/active/save`,
        edit:`${base.url}/crs36/active/edit`,
        editStatus:`${base.url}/crs36/active/editStatus`,
      },
      user:{
        qurey:`${base.url}/crs36/activeuser/list`,
        edit:`${base.url}/crs36/activeuser/edit`,
        export:`${base.url}/crs36/activeuser/export`,
      },
      black:{
        qurey:`${base.url}/crs36/activeblacklist/list`,
      },
      bonus:{
        qurey:`${base.url}/crs36/activeuserbonus/list`,
        export:`${base.url}/crs36/activeuserbonus/export`,
      }
  },


  task:{
    query:`${base.url}/crs36/task/activity/page`,
    queryType:`${base.url}/crs36/task/type/findByTypeList`,
    addOrUpdate:`${base.url}/crs36/task/activity/save`,
    productUrl:`${base.url}/crs36/task/activity/product/`,
    productListUrl:`${base.url}/crs36/task/activity/productList`,
    copy:`${base.url}/crs36/task/activity/copyActivity`,
    status:`${base.url}/crs36/task/activity/audit/`,
    importBlacklist:`${base.url}/crs36/task/user/importBlacklist`,
    addUserAssign:`${base.url}/crs36/task/user/addUserAssign`,
    statistical:`${base.url}/crs36/task/activity/findByActivityStatistics`,
    userQuery:`${base.url}/crs36/task/user/page`,
    exportTaskUserActivityList:`${base.url}/crs36/task/user/exportTaskUserActivityList`,
    rewardPage:`${base.url}/crs36/task/user/rewardPage`,
    exportTaskUserRewardActivityList:`${base.url}/crs36/task/user/exportTaskUserRewardActivityList`,
    blacklistPage:`${base.url}/crs36/task/user/blacklistPage`,
    assignUserPage:`${base.url}/crs36/task/user/assignUserPage`,
    deleteUserBlacklist:`${base.url}/crs36/task/user/deleteUserBlacklist`,
    findByActivityStatistics:`${base.url}/crs36/task/activity/findByActivityStatistics`,
    updateUser:`${base.url}/crs36/task/user/updateUser`,
  },
  taskType:{
    query:`${base.url}/crs36/task/type/page`,
    audit:`${base.url}/crs36/task/type/audit`,
    addOrUpdate:`${base.url}/crs36/task/type/save`,
  },
  taskGolden:{
    query:`${base.url}/crs36/task/golden/page`,
    audit:`${base.url}/crs36/task/golden/audit`,
    addOrUpdate:`${base.url}/crs36/task/golden/save`,
    findByGoldenList:`${base.url}/crs36/task/golden/findByGoldenList`,
  },
  luckyRedPacket: {
    query:`${base.url}/crs36/luckyRedPacket/list`,
    save: `${base.url}/crs36/luckyRedPacket/save`,
    edit: `${base.url}/crs36/luckyRedPacket/edit`,
    del: `${base.url}/crs36/luckyRedPacket/del`,
    updateStatus: `${base.url}/crs36/luckyRedPacket/updateStatus`,
    addUser: `${base.url}/crs36/luckyRedPacketUser/addUser`,
    black: `${base.url}/crs36/luckyRedPacketBlack/black`,
    stopStatus: `${base.url}/crs36/luckyRedPacket/stopStatus`,
    infoInit: `${base.url}/crs36/luckyRedPacket/infoInit`,
    userList:`${base.url}/crs36/luckyRedPacketUser/list`,
    recordList:`${base.url}/crs36/luckyRedPacketRecord/list`,
    blackList:`${base.url}/crs36/luckyRedPacketBlack/list`,
    blackDelete:`${base.url}/crs36/luckyRedPacketBlack/del`,
  },
  //上传图片
  img:{
    upload:`${base.url}/cloud/file/uploadImage`,
  },
  luckyDraw: {
    lucky:{
      query:`${base.url}/crs36/luckyDraw/page`,
      save: `${base.url}/crs36/luckyDraw/save`,
      info: `${base.url}/crs36/luckyDraw/getinfo`,
      getProductionList: `${base.url}/crs36/luckyDraw/getProductionList`,
      applyStatus: `${base.url}/crs36/luckyDraw/applyStatus`,
      delete: `${base.url}/crs36/luckyDraw/delete`,
      importBlack: `${base.url}/crs36/luckyDraw/importBlack`,
    },
    user:{
      query:`${base.url}/crs36/luckyDraw/user/page`,
      analyse:`${base.url}/crs36/luckyDraw/user/analyse/page`,
      updateLuckyUserNum:`${base.url}/crs36/luckyDraw/user/updateLuckyUserNum`,
      export:`${base.url}/crs36/luckyDraw/user/export`,
    },
    black:{
      query:`${base.url}/crs36/luckyDraw/black/page`,
    },
    record:{
      query:`${base.url}/crs36/luckyDraw/record/page`,
      handAddBonus:`${base.url}/crs36/luckyDraw/record/handAddBonus`,
      export:`${base.url}/crs36/luckyDraw/record/export`,
      prizeList:`${base.url}/crs36/luckyDraw/record/getRecordPrize`,
      winningThePrizeSum:`${base.url}/crs36/luckyDraw/record/getWinningThePrizeSum`,
    },
  },
  commission:{
    active:{
      query:`${base.url}/crs36/commissionActive/list`,
      edit:`${base.url}/crs36/commissionActive/edit`,
      del:`${base.url}/crs36/commissionActive/del`,
      getProduction:`${base.url}/crs36/commissionActive/getProduction`,
      apply:`${base.url}/crs36/commissionActive/apply`,
      end:`${base.url}/crs36/commissionActive/end`,
      levelList:`${base.url}/crs36/commissionActive/levelList`,
    },
    user:{
      query:`${base.url}/crs36/commissionUser/list`,
      import:`${base.url}/crs36/commissionUser/import`,
      apply:`${base.url}/crs36/commissionUser/apply`,
      end:`${base.url}/crs36/commissionUser/end`,
    },
    day:{
      query:`${base.url}/crs36/commissionDay/list`,
      updateAmount:`${base.url}/crs36/commissionDay/updateAmount`,
      apply:`${base.url}/crs36/commissionDay/apply`,
      handAddBonus:`${base.url}/crs36/commissionDay/handAddBonus`,
    },
    trade:{
      query:`${base.url}/crs36/commissionTrade/list`,
    },
  },
  experience:{
    list:{
      qurey:`${base.url}/crs36/experience/list`,
      edit:`${base.url}/crs36/experience/edit`,
      apply:`${base.url}/crs36/experience/apply`,
      del:`${base.url}/crs36/experience/del`,
    },
    user:{
      qurey:`${base.url}/crs36/experience/user/list`,
      edit:`${base.url}/crs36/experience/user/edit`,
      apply:`${base.url}/crs36/experience/user/apply`,
      del:`${base.url}/crs36/experience/user/del`,
      uploadTemplate:`${base.url}/crs36/experience/user/uploadTemplate`,
      uploadUser:`${base.url}/crs36/experience/user/uploadUser`,
      download:`${base.url}/crs36/experience/user/download`,
    },
    black:{
      qurey:`${base.url}/crs36/experience/black/list`,
      edit:`${base.url}/crs36/experience/black/edit`,
      del:`${base.url}/crs36/experience/black/del`,
      uploadUser:`${base.url}/crs36/experience/black/uploadUser`,
    },
  },
  autoMsg:{
    mode:{
      qurey:`${base.url}/crs36/autoMsg/mode/list`,
      edit:`${base.url}/crs36/autoMsg/mode/edit`,
      del:`${base.url}/crs36/autoMsg/mode/del`,
    },
    user:{
      qurey:`${base.url}/crs36/autoMsg/user/list`,
    },
  },

};


